import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

const ContactForm: React.FC = () => {
  const [state, handleSubmit] = useForm('xzdqzzqe');
  const hasFormErrors = (state.errors?.getFormErrors().length ?? 0) > 0;

  if (state.succeeded) {
    return (
      <div className="contact-form-success" role="status" aria-live="polite">
        Bedankt voor je bericht. Ik reageer zo snel mogelijk.
      </div>
    );
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <input type="text" name="_gotcha" className="honeypot-input" tabIndex={-1} autoComplete="off" />

      <div className="contact-form-field">
        <label htmlFor="contact-name">Naam</label>
        <input id="contact-name" type="text" name="name" placeholder="Je naam" required />
      </div>

      <div className="contact-form-field">
        <label htmlFor="contact-email">E-mail</label>
        <input id="contact-email" type="email" name="email" placeholder="jij@voorbeeld.nl" required />
        <ValidationError className="contact-form-error" prefix="Email" field="email" errors={state.errors} />
      </div>

      <div className="contact-form-field">
        <label htmlFor="contact-message">Bericht</label>
        <textarea id="contact-message" name="message" placeholder="Waarmee kan ik je helpen?" rows={5} required />
        <ValidationError className="contact-form-error" prefix="Message" field="message" errors={state.errors} />
      </div>

      {hasFormErrors && (
        <p className="contact-form-error" role="alert">
          Er ging iets mis met verzenden. Probeer het opnieuw.
        </p>
      )}

      <button type="submit" className="contact-submit-button" disabled={state.submitting}>
        {state.submitting ? 'Verzenden...' : 'Verstuur bericht'}
      </button>
    </form>
  );
};

export default ContactForm;